import {AMENITY_CONFIGS} from "@/src/modules/amenities/lib/amenity-config";
import type {AmenityType} from "@/src/modules/amenities/types";
import {FEATURE_NAMES, ICONS} from "@/src/modules/routing/utils/constants";

export function getResidentHomeAmenityTypeMeta(type: AmenityType) {
  const config = AMENITY_CONFIGS.find((entry) => entry.type === type);
  const sectionKey = config?.facilitiesSectionKey ?? type;
  const featureLabel = FEATURE_NAMES[sectionKey as keyof typeof FEATURE_NAMES];
  const icon = ICONS[sectionKey] ?? ICONS.pools;

  return {
    label: featureLabel ?? config?.labelFacilitySingular ?? type,
    icon,
  };
}
